<template>
  <div class="d-flex flex-column privilege-form">
    <span class="font-weight-bold font-size-16">General</span>

    <a-form-model-item required prop="privilegeName" :colon="false" class="normal-size">
      <template #label>
        <span class="title" style="line-height: 1;">
          Name
          <span style="font-weight: 400; color: #8c8c8c;">
            (for internal usage)
          </span>
        </span>
        <a-tooltip slot="suffix" title="Visible only in admin panel">
          <a-icon type="info-circle" class="text-primary" />
        </a-tooltip>
      </template>
      <a-input v-model="form.privilegeName" placeholder="Name" size="large" :disabled="loading" />
    </a-form-model-item>

    <ActivityPeriods
      ref="activity-periods"
      class="mb-2"
      :showIndex="false"
      :periods="form.periods"
      :loading="loading"
      @update="handleUpdatePeriods"
    />

    <a-form-model-item prop="section" label="Section" :colon="false" required class="section-radio">
      <a-radio-group name="radioGroup" v-model="form.section">
        <a-radio value="screens"> Screens </a-radio>
        <a-radio value="viewscreen" disabled> Viewscreen </a-radio>
      </a-radio-group>
    </a-form-model-item>

    <template v-if="form.section === 'screens'">
      <a-form-model-item
        prop="privilegeScreens"
        :colon="false"
        style="max-width: 427px;"
      >
        <a-select
          v-model="form.privilegeScreens"
          :disabled="loading"
          size="large"
          mode="multiple"
          allow-clear
          showArrow
        >
          <template #placeholder><span style="color: #a1a1c2;">Select screens</span></template>
          <a-select-option v-for="screen in screens" :key="screen.value" :value="screen.value">
            {{ screen.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
     <a-form-model-item prop="privilegeSegments" required  :colon="false" style="max-width: 427px;">
        <template #label>
          <SegmentsLabel />
        </template>
        <div class="d-flex align-items-center w-full">
          <SegmentsSelect v-model="form.privilegeSegments" :segments="segments" :loading="localLoading" @change="handleSegmentsChange" />
        </div>
      </a-form-model-item>
    </template>

    <template v-else-if="form.section === 'viewscreen'">
      <a-form-model-item
        :colon="false"
        style="max-width: 427px;"
      >
        <a-select
          v-model="form.privilegeViewscreens"
          :disabled="loading"
          size="large"
          mode="multiple"
          allow-clear
          showArrow
        >
          <template #placeholder><span style="color: #a1a1c2;">Select viewscreens</span></template>
          <!-- <a-select-option v-for="screen in screens" :key="screen.value" :value="screen.value">
            {{ screen.label }}
          </a-select-option> -->
        </a-select>
      </a-form-model-item>
    </template>

    <a-row>
      <a-form-model-item prop="privilegeApps" required :colon="false" class="d-block">
        <template #label>
          <span class="mr-4">Apps</span>
          <a
            v-if="form.section === 'screens'"
            style="color: rgb(0, 123, 255) !important; font-weight: 400"
            @click.stop="openAddAppModal"
          >
            + Add
          </a>
        </template>
        <div v-if="form.privilegeApps">
          <a-tag
            v-for="app in form.privilegeApps.slice(0, 5)"
            :key="app.id"
            style="
              margin-right: 15px;
              padding: 1px 8px;
              border-radius: 2px;
            "
          >
            {{ app.name }}
            <a-icon v-if="app.platform.toLowerCase() === 'android'" type="android" class="ml-1 text-success" />
            <a-icon v-if="app.platform.toLowerCase() === 'ios'" type="apple" class="ml-1 text-primary" />
            <a-icon v-if="app.platform.toLowerCase() === 'web'" type="global" class="ml-1 text-default" />
          </a-tag>
          <a-tag v-if="form.privilegeApps.length > 4"> ... </a-tag>
        </div>
      </a-form-model-item>
    </a-row>
  </div>
</template>
<script>
import ActivityPeriods from '@/components/custom/ActivityPeriods.vue'
import SegmentsSelect from '@/components/custom/segments/segmentsSelect.vue'
import SegmentsLabel from '@/components/custom/segments/segmentsLabel.vue'

export default {
  name: 'privilegeFormGeneral',
  components: {
    ActivityPeriods,
    SegmentsSelect,
    SegmentsLabel,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    loading: Boolean,
    screens: Array,
    segments: Array,
  },
  data() {
    return {
      localLoading: this.loading,
      form: this.value,
    }
  },
  methods: {
    addDateRange() {
      if (!this.form?.periods?.length) {
        return
      }

      this.form.periods.push({
        startDate: null,
        endDate: null,
      })
    },
    removeDateRange(index) {
      this.form.periods.splice(index, 1)
    },
    disableDatesBeforeToday(dateObj) {
      const startValue = dateObj.startDate
      const endValue = dateObj.endDate

      if (!startValue || !endValue) {
        return startValue && startValue < this.$moment().add(-1, 'day').endOf('day')
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(dateObj) {
      const startValue = dateObj.startDate
      const endValue = dateObj.endDate

      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    openAddAppModal() {
      this.$emit('openAppModal')
    },
    handleSegmentsChange() {
      this.$emit('validateField', 'privilegeSegments')
    },
    handleUpdatePeriods(data) {
      this.$emit('updatePeriods', data)
    },
  },
  watch: {
    value(newVal) {
      this.form = JSON.parse(JSON.stringify(newVal))
    },
  },
}
</script>

<style lang="scss">
.section-radio .ant-form-item-control {
  line-height: 1;
  margin-top: 5px;
}
</style>
